export interface MmmProjectRouteContext {
  projectId: string
  isDashboardRoute: boolean
  hasDashboardAccess: boolean
}

export type MmmProjectRouteResolution =
  | { action: 'proceed' }
  | { action: 'redirect', path: string }

export function resolveMmmProjectRoute(context: MmmProjectRouteContext): MmmProjectRouteResolution {
  // Dashboard routes render for every project: demo data until monitoring is enabled.
  if (context.isDashboardRoute) {
    return { action: 'proceed' }
  }

  return context.hasDashboardAccess
    ? { action: 'redirect', path: `/project/${context.projectId}/market-maker-monitoring/dashboard` }
    : { action: 'proceed' }
}
